import script from "./AssetManagementPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AssetManagementPage.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__